<template>
  <div class="animated fadeIn list-of-aexpense">
    <b-card>
      <div slot="header">List of Expense Reimbursment 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="print" >Print Form</b-dropdown-item>
            <b-dropdown-item @click="printjv" :disabled="(model.posting == 0)">Jurnal Voucher</b-dropdown-item>
            <b-dropdown-item @click="printjvmultiple" :disabled="(selected.length==0)">Jurnal Voucher Selected ({{selected.length}}) </b-dropdown-item>
            <b-dropdown-item @click="printpb" >Perintah Bayar</b-dropdown-item>
            <b-dropdown-item @click="printpbmultiple" :disabled="(selected.length==0)">Perintah Bayar Selected ({{selected.length}}) </b-dropdown-item>
          </b-dropdown>
          <!-- <b-button variant="primary mr-1" @click="posting()"><i class="fa fa-paper-plane"></i> Accrued</b-button> -->
          <b-dropdown text="Posting/Accrue" variant="primary mr-1" >
            <b-dropdown-item @click="posting" :disabled="!(model.expenKey) || model.posting==1 || selected.length>0">Posting 1</b-dropdown-item>
            <b-dropdown-item @click="postingselected" :disabled="(selected.length==0)">Posting Selected {{selected.length}} </b-dropdown-item>
            <!-- <b-dropdown-item @click="postingall" >Accrued All</b-dropdown-item> -->
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="unposting" :disabled="!(model.expenKey)|| model.posting==0 || selected.length>0">Unposting 1</b-dropdown-item>
            <b-dropdown-item @click="unpostingselected" :disabled="(selected.length==0)">Unposting Selected {{selected.length}} </b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary mr-1" @click="approvalConfirm()"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>

        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>

            <b-input-group >
              <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" style="width:23% !important;"></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" style="width:23% !important;"></b-form-input>
                <b-input-group-prepend><span class="ml-2 pt-2">Outstand &nbsp;</span></b-input-group-prepend>
                <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.YesNoAll" style="padding:0 !important;"></b-form-select>
            </b-input-group>
            <b-row>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><label>Paid To</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.dibayarke" placeholder="Pay to"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label >Request Number</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" placeholder="% for wildcard"></b-form-input>
                    </b-input-group>
                  </b-col>
              </b-row>                      

        </b-col>
        <b-col lg="6">
              <b-row>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>Expense AP Acc.</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.kodeacc" placeholder="Account Code"></b-form-input>
                      </b-input-group>
                  </b-col>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Acc. Name&nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.namaacc" placeholder="Account Name"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>      
              <b-row>
                <b-col  lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Approval status</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.statuswf" :plain="true" :options="dataList.approvalStatus"></b-form-select>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label >Posted/Accrued</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.posting" :plain="true" :options="dataList.YesNoAll" style="padding:0 !important;"></b-form-select>
                    </b-input-group>
                  </b-col>
              </b-row>                      

            <b-input-group >
              <b-input-group-prepend><label>Create By</label></b-input-group-prepend>
              <b-form-input v-model="tblData.createby" placeholder="input by" style="width:30% !important;"></b-form-input>
              <b-input-group-prepend><span class="pt-2">Refer iDoc</span></b-input-group-prepend>
              <b-form-select v-model="tblData.iDocsURL" :plain="true" :options="dataList.YesNoAll" style="padding:0 !important;"></b-form-select>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
              <b-input-group-append>
                    <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
              </b-input-group-append>
              <b-input-group-append>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>

        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
          @row-clicked="rowClicked" 
      >
        <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-expenKey="data.item.expenKey"
            :checked="ischeckedjurnal(data.item.expenKey)"
          />
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template v-slot:head(selected)="data">
                  <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
                    <i class="fa fa-eraser"></i>
                  </a>
        </template>        
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#" :disabled="(((data.item.posting==1) || (data.item.nomorbank)) || ((data.item.send2wf==1) && (data.item.isreviewed==0)) || (data.item.iscomplete==1))" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#"  style="padding:0 !important;">Print Form</b-dropdown-item>
          <b-dropdown-item @click="rowPrintpb(data.item)" href="#" v-if="(data.item.statuswf=='111')" style="padding:0 !important;">Print Perintah Bayar</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" v-if="(data.item.statuswf=='111')" :disabled="((data.item.posting==1) || (data.item.nomorbank))" style="padding:0 !important;">Posting</b-dropdown-item>
          <b-dropdown-item @click="rowUnPost(data.item)" href="#" v-if="(data.item.statuswf=='111')" :disabled="(data.item.posting==0)" style="padding:0 !important;">Un Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPrintJv(data.item)" href="#" v-if="(data.item.statuswf=='111')" :disabled="(data.item.posting==0)" style="padding:0 !important;">Print JV</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="((data.item.posting==1) || (data.item.nomorbank))" style="padding:0 !important;"> Delete</b-dropdown-item>
          <b-dropdown-item @click="iDocsForm(data.item)" href="#"  style="padding:0 !important;">link iDocs</b-dropdown-item>
          <b-dropdown-item @click="rowApproval(data.item)" href="#"  style="padding:0 !important;">Approval</b-dropdown-item>
        </b-dropdown>
      </template>    
        <template v-slot:cell(nomor)="data">
            <span v-if="((data.item.posting==1) || (data.item.nomorbank))" >{{data.item.nomor}}</span>
            <span v-else style="background-color:yellow;"> {{data.item.nomor}}</span>
        </template>

        <template v-slot:cell(tglRequ)="data">
          {{ data.item.tglRequ | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(final)="data">
          <span v-if="data.item.final==1">Final</span>
          <span v-else style="background-color:#a9a6a6;">Draft</span>
        </template>
        <template v-slot:cell(jumlah)="data">
          <span v-if="data.item.final==0" style="background-color:#a9a6a6;">           
            {{(data.item.jumlah)|numFormat}}
          </span>
          <span v-else> 
            <span v-if="((data.item.posting==1) || (data.item.nomorbank))">           
                {{data.item.jumlah|numFormat}}
            </span>
            <span v-else style="background-color:yellow;"> 
                {{data.item.jumlah|numFormat}}
            </span>
          </span>
        </template>
        <template v-slot:cell(nilaiByr)="data">
          {{data.item.nilaiByr|numFormat}}
        </template>
        <template v-slot:cell(outstand)="data">
          {{data.item.outstand|numFormat}}
        </template>
        <template v-slot:cell(iDocsURL)="data">
          <b-link @click="open_iDocs(data.item)" v-if="(data.item.iDocsURL)">iDoc</b-link>
        </template>
        <template v-slot:cell(issuccess)="data">
          <div v-if="data.item.send2wf==0" style="background-color:yellow;">           
            DRAFT
          </div>
          <div v-else> 
            <div v-if="data.item.iscomplete==0">           
              ON PROCESS
            </div>
            <div v-else>           
                <div v-if="data.item.issuccess==1"  style="background-color:#04f681;">           
                  APPROVED
                </div>
                <div v-else style="background-color:#f86c6b;">           
                  REJECTED
                </div>
            </div>
          </div>
        </template>

      </b-table>
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3" >
          <div class="text-right pt-1">
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-4">Record Not Posted</span>
            <span style="background-color:#a9a6a6;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Draft</span>
          </div>
        </b-col>        
      </b-row>      

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" scrollable size="xl" title="Preview as PDF" hide-footer>
        <iframe :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>

    <b-modal v-model="showFrmIdocs" header-bg-variant="primary"  title="Link to iDocs - Form" size="lg" :centered="true" @ok="idocsUpdate" ok-title="Save">
      <b-row>
              <b-col lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.nomor" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label class="text-right">Request Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.tglRequ" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-form-row>
              <b-col lg="7">
                  <b-input-group >
                      <b-input-group-prepend><label>Request By</label></b-input-group-prepend>
                      <b-form-input readonly v-model="model.crewinfo" ></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="5">
                  <b-input-group >
                  <b-input-group-prepend><span class="p-2">Internal Budget</span></b-input-group-prepend>
                  <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                  </b-input-group>
              </b-col>
          </b-form-row>                      
          <b-input-group >
              <b-input-group-prepend><label>Description</label></b-input-group-prepend>
              <b-form-input v-model="model.keterangan"  readonly></b-form-input>
          </b-input-group>
          <b-form-row>
              <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Reimburs Amount</label></b-input-group-prepend>
                      <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                      </b-input-group-prepend>
                      <my-number :minus="true" class="form-control text-right" v-model="model.jumlah" :precision="2" disabled></my-number>
                  </b-input-group>
              </b-col>
          </b-form-row>                      

          <b-input-group >
                        <b-input-group-prepend><label >iDocs Documents</label></b-input-group-prepend>
                        <b-input-group-prepend>
                                <span class="input-group-text" >EXPENSE REIMBURSMENT</span>
                        </b-input-group-prepend>
                        <b-form-input v-model="model.iDocsURL" placeholder="iDocs URL"></b-form-input>
                        <b-input-group-append >
                            <b-btn text="Button" @click="show_iDocs()" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                        </b-input-group-append>
                        <b-input-group-append v-if="(model.iDocsURL)">
                            <b-btn text="Button" variant="success" @click="open_iDocs(model)" >
                                Open
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>

    </b-modal>

      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.nomor" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label class="text-right">Request Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.tglRequ" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-form-row>
              <b-col lg="7">
                  <b-input-group >
                      <b-input-group-prepend><label>Request By</label></b-input-group-prepend>
                      <b-form-input readonly v-model="model.crewinfo" ></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="5">
                  <b-input-group >
                  <b-input-group-prepend><span class="p-2">Internal Budget</span></b-input-group-prepend>
                  <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                  </b-input-group>
              </b-col>
          </b-form-row>                      
          <b-form-row>
              <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Reimburs Amount</label></b-input-group-prepend>
                      <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                      </b-input-group-prepend>
                      <my-number :minus="true" class="form-control text-right" v-model="model.jumlah" :precision="2" disabled></my-number>
                  </b-input-group>
              </b-col>
              <!-- <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label class="text-right">Reimburs Amount</label></b-input-group-prepend>
                      <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                      </b-input-group-prepend>
                      <my-number :minus="true" class="form-control text-right" v-model="model.jumlah" :precision="2" disabled></my-number>
                  </b-input-group>
              </b-col> -->
          </b-form-row>                      

          <b-input-group >
              <b-input-group-prepend><label>Description</label></b-input-group-prepend>
              <b-form-input v-model="model.keterangan"  readonly></b-form-input>
          </b-input-group>
          <div v-if="(this.model.send2wf==1)">
            <label>Workflow process history</label>
              <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="5" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                  <b-button variant="danger" class="ml-1" v-if="((model.iscomplete==0)  || (model.isreject==1) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
              <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                  <label style="width:260px !important;">Send without attachment, are you sure?</label>
                    <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
              </b-row>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                  <b-button variant="secondary" class="ml-1"  @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>
      <b-modal v-model="actionHistoryShow" header-bg-variant="primary"  title="Action History" size="lg" :centered="true" ok-only>
          <b-row>
              <b-col lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.nomor" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label class="text-right">Request Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.tglRequ" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-form-row>
              <b-col lg="7">
                  <b-input-group >
                      <b-input-group-prepend><label>Request By</label></b-input-group-prepend>
                      <b-form-input readonly v-model="model.crewinfo" ></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="5">
                  <b-input-group >
                  <b-input-group-prepend><span class="p-2">Internal Budget</span></b-input-group-prepend>
                  <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                  </b-input-group>
              </b-col>
          </b-form-row>                      
          <b-form-row>
              <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Reimburs Amount</label></b-input-group-prepend>
                      <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                      </b-input-group-prepend>
                      <my-number :minus="true" class="form-control text-right" v-model="model.jumlah" :precision="2" disabled></my-number>
                  </b-input-group>
              </b-col>
              <!-- <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label class="text-right">Reimburs Amount</label></b-input-group-prepend>
                      <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                      </b-input-group-prepend>
                      <my-number :minus="true" class="form-control text-right" v-model="model.jumlah" :precision="2" disabled></my-number>
                  </b-input-group>
              </b-col> -->
          </b-form-row>                      

          <b-input-group >
              <b-input-group-prepend><label>Description</label></b-input-group-prepend>
              <b-form-input v-model="model.keterangan"  readonly></b-form-input>
          </b-input-group>
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="120px">Action Date</th>
                    <th >Comment</th>
                    <th width="100px">Action By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in actionHistory" :key="row.reqactionkey">
                    <td> {{row.actiondate | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>{{row.actiondtl}}</td>
                    <td>{{row.actionby}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
      </b-modal>

  </div>
</template>

<style lang="scss">
.list-of-aexpense {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
  .input-group {
      .input-group-prepend {
          label {
              width: 110px !important;
          }
      }
  }  
 }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import expense from "../../apis/expense";
import task from "../../apis/task";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();


export default {
  components: {Loading},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showFrmIdocs:false,showUnsubmitConfirm:false,
      showPostingConfirm: false,showUnpostConfirm: false,
      use_wfservice:this.$store.state.user.use_wfservice,
      isLoading:false,
      showReport:false,
      isprintjv: false,
      reportUrl: null,
      model:{},
      uanguser: this.$store.state.user.matauang,
      items: [],
      pagination:false,
      limit:20,
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2: moment().format('YYYY-MM-DD'),                
        sortBy: 'nomor',
        sortDesc: true,
        DimCol:'Dim1',outstand:'', statuswf:''
      },
      dataList: {
        YesNoAll: dropdown.YesNoAll,
        approvalStatus: dropdown.approvalStatus
      },      
      selected:[],
      actionHistoryShow:false,
      actionHistory:[],   
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalCancelConfirm: false,
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "selected",
            label: "",
            thStyle: "width:20px",
            thClass:"text-center",
            tdClass:"text-center",
          },
          {
            key: "issuccess",
            label: "Approval Status",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Trx. Number",
            sortable: true
          },
          {
            key: "tglRequ",
            thStyle: "width:90px",
            label: "Trx. Date",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
            sortable: true
          },
          {
            key: "crewinfo",
            label: "Create By",
            sortable: true
          },
          {
            key: "dibayarke",
            label: "Paid To",
            sortable: true
          },
          {
            key: "iDocsURL",
            label: "",
            thClass:"text-center",
            tdClass:"text-center",
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "jumlah",
            label: "Requested Amount",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nilaiByr",
            label: "Paid",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nomorbank",
            label: "Trx.Bank/Cash",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "outstand",
            label: "Outstanding",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        // this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
  },
  methods: {
    ischeckedjurnal(val){
      const findjv = this.selected.find(x => x === val);
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedclear() {
      this.selected = [];
      // uncheck setelah posting selected
      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach(element => {
        element.checked= false;
      });
      // $('[name="selectjurnal"]').each(function() {
      //     $(this).prop("checked", false);
      //   });
    },
    checkedjurnal(item,record) {
      this.rowClicked(record);
      const expenKey = item.target.attributes["data-expenKey"].value;
      if (item.target.checked) {
        const findjv = this.selected.find(x => x === expenKey);
        if (!(findjv)){
          this.selected.push(expenKey);
        }
      } else {
        const findIdx = this.selected.findIndex(x => x === expenKey);
        this.selected.splice(findIdx, 1);
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
      this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.expreqlist) {
            this.tblData[key] = filter.expreqlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.expreqlist.tgl1 || '';
          this.tblData.tgl2=filter.expreqlist.tgl2 || '';
          this.showFilter=filtered;
          delete filter.expreqlist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
                try {
          const list = await expense.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
                try {
          const list = await expense.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    clearFilter(ctx) {
        this.tblData.kodeaccc= '';
        this.tblData.namaacc=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.dibayarke=  '';
        this.tblData.createby=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'dibayarke', 'kodeacc', 'namaacc', 'isProject', 'crewkey', 'crewname','createby', 'final'];
      let filtered = false;
      const expreqlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              expreqlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          expreqlist.page=this.tblData.page;
          expreqlist.limit=this.tblData.limit;
          expreqlist.sortBy=this.tblData.sortBy;
          expreqlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.expreqlist=expreqlist;
          this.$store.commit("filter", filter);
      }
    },     
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
        this.posting();        
    },
    rowUnPost(record) {
      this.rowClicked(record);
        this.unposting();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },    
    rowPrintJv(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowPrintpb(record) {
      this.rowClicked(record);
        this.printpb();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },
    rowApproval(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    approvalConfirm: async function () {
        if (this.model.expenKey) {
            if (this.model.send2wf==1) {
              try {
                const data = await task.approvalhistory({key: this.model.expenKey});
                this.approvalHistory=data;                
              } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                
              }
            }
            this.model.tglRequ = this.model.tglRequ ? moment(this.model.tglRequ).format('YYYY-MM-DD') : '';
                this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.expenKey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await expense.approval(formData);
            this.model.send2wf=1;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await expense.approvalUndo(this.model);
            this.model.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.expenKey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await task.approvalprint({key: this.model.expenKey});
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },      

    add(){
      this.saveFilter();
      router.push({name :"advance.expreimbursfrm"});
    },
    edit: function() {
        if (this.model.expenKey) {
          this.saveFilter();
          router.push({name :'advance.expreimbursfrm', params: { expenKey: this.model.expenKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.expenKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
        this.isLoading=true;
        await expense.remove(this.model);
        this.refresh();
        // const index= this.items.findIndex(r => (r.expenKey==this.model.expenKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
    },
    
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    iDocsForm: function (record) {
      this.rowClicked(record);
        if (this.model.expenKey) {
                this.showFrmIdocs = true;
        } else {
            toastr.warn('Please select a row that want to be link to Idocs!');
        }
    },     
    idocsUpdate: async function(){
      if ((this.model.iDocsURL) && (this.model.iDocsURL.includes(process.env.VUE_APP_IDOCS_URL_BASE))) {
            this.isLoading=true;
            try {
                await expense.idocs(this.model);
                this.isLoading=false;
            } catch (error) {
                this.isLoading=false;
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        } else {
            toastr.error('URL of iDocs Document is invalid ','ERROR MESSAGE',10000);
        }
    },  
    posting: async function () {
        if (this.model.expenKey) {
            if (this.model.posting == 0) {
              if ((this.model.matauang!=this.uanguser) && ((this.model.ratekurs || 1)==1))
              {
                toastr.warn(`Please EDIT and fill the Exchange Rate ${this.model.matauang} !`);
              } else {
                this.showPostingConfirm = true;
              }
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    },
    unposting:async function () {
        if (this.model.expenKey) {
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    },
    postingselected: async function() {
      this.isLoading = true;
      try {
        if (this.selected.length > 0) {
          await expense.postingselected(this.selected);
          this.printjvmultiple();
          this.refresh();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          toastr.warn("Please select row(s) that want to be Posting!");
        }
      } catch (error) {
        this.isLoading = false;
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    unpostingselected: async function() {
      this.isLoading = true;
      try {
        if (this.selected.length > 0) {
          await expense.unpostingselected(this.selected);
          this.selected = [];
          this.refresh();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          toastr.warn("Please select row(s) that want to be Posting!");
        }
      } catch (error) {
        this.isLoading = false;
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    postingData: async function(){
        this.isLoading=true;
        try {
            await expense.posting(this.model);
            this.model.posting=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await expense.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },  
    print: async function()
    {
      if (this.model.expenKey) {
          try {
                this.showReport=true;
              this.reportUrl= await expense.print(this.model);
              this.isprintjv=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printpb: async function()
    {
      if (this.model.expenKey) {
          try {
                this.showReport=true;
              this.reportUrl= await expense.printpb(this.model);
              this.isprintjv=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printpbmultiple: async function()
    {
      if (this.selected) {
          try {
                this.showReport=true;
              this.reportUrl= await expense.printpbmultiple(this.selected);
              this.isprintjv=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },

    printjv: async function()
    {
      if (this.model.expenKey) {
          try {
                this.showReport=true;
              this.reportUrl= await expense.printjv(this.model);
              this.isprintjv=true;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    editjv: function() {
        if (this.model.expenKey) {
            this.saveFilter();
            const tanggal = moment(this.model.tanggal).format('YYYY-MM-DD');
          // router.push({name :'advance.editjvfrm', params: { nomor: this.model.nomor, tanggal, kodejurnal:'APINV', fsubkode2:'ap_invoice_tt',kodefield2:'apinvkey',subkode2: this.model.apinvkey}});
          router.push({name :'advance.editjvfrm', params: { nomor: this.model.nomor, tanggal: this.model.tglRequ}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },    

    printjvmultiple: async function()
    {
      if (this.selected) {
          try {
                this.showReport=true;
              this.reportUrl= await expense.printjvmultiple(this.selected);
              this.isprintjv=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
              this.selected = [];
          } catch (error) {
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
            const response = await expense.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/advance/home");
    },    
    async show_iDocs() {
        this.$show_iDocs({cat:2});
    },
    async open_iDocs(doc) {
      this.$open_iDocs(doc, (state) => this.isLoading = state);
    },
  }
};
</script>
